import React, { useEffect, useState } from 'react'
import './App.css'
import Login from './components/Login'
import Navigation from './layouts/Nav'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import SignUp from './components/Signup'
import './styles.scss'
import Dashboard from './components/Dashboard'
import HomeNav from './layouts/HomeNav'
import Services from './components/Services'
import MyBusiness from './components/MyBusiness'
import Availability from './components/Availability'
import Search from './components/Search'
import Profile from './components/Profile'
import EditProfile from './components/EditProfile'
import Chat from './components/Chat'
import Stylers from './components/Stylers'
import ClientServices from './Client/Components/ClientServices'
import ClientHeader from './Client/Components/ClientHeader'
import ClientNav from './Client/Components/ClientNav'
import Home from './Client/Components/Home'
import ClientSearch from './Client/Components/ClientSearch'
import { ScaleLoader } from 'react-spinners'

function App() {
  let user = JSON.parse(localStorage.getItem('user'))
  let isLoading = JSON.parse(localStorage.getItem('isLoading'))
  console.log({ isLoading })
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    localStorage.setItem('isLoading', JSON.stringify(false))
    if (user == null && location.pathname !== '/sign-up') {
      navigate('/login')
    } else if (
      user &&
      location.pathname === '/login' &&
      user?.user_type === 'provider'
    ) {
      navigate('/dashboard')
    } else if (
      user &&
      location.pathname === '/login' &&
      user?.user_type === 'client'
    ) {
      navigate('/home')
    }
  }, [])

  return (
    <>
      <div className="App">
        {user != null ? (
          user?.user_type === 'client' ? (
            <ClientNav />
          ) : (
            <HomeNav />
          )
        ) : (
          <Navigation />
        )}
        <Routes>
          <Route path="/dashboard" exact element={<Dashboard />} />
          <Route path="/home" exact element={<Home />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/sign-up" exact element={<SignUp />} />
          <Route path="/" exact element={<Login />} />
          <Route path="/styles" exact element={<Services />} />
          <Route path="/stylers" exact element={<Stylers />} />
          <Route path="/services" exact element={<ClientServices />} />
          <Route path="/search" exact element={<Search />} />
          <Route path="/client-search" exact element={<ClientSearch />} />
          <Route path="/profile" exact element={<Profile />} />
          <Route path="/stylist-profile/:id" exact element={<Profile />} />
          <Route path="/availability" exact element={<Availability />} />
          <Route path="profile/editProfile" exact element={<EditProfile />} />
          <Route path="/my-business" exact element={<MyBusiness />} />
          <Route path="/chat" exact element={<Chat />} />
        </Routes>
      </div>
    </>
  )
}

export default App
